import { createApp } from 'vue'
import App from './App.vue'
import router from './router/new.js'  // 确保路径正确
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'animate.css'  // 添加 animate.css 用于动画效果
import axios from 'axios'
import request from './utils/request'
import { ElMessage } from 'element-plus'

// 全局错误处理
window.addEventListener('error', (event) => {
  // 检查 event 和 event.message 是否存在
  if (event?.message && typeof event.message === 'string' && 
      (event.message.includes('ResizeObserver') || 
       event.message.includes('ResizeObserver loop limit exceeded'))) {
    event.stopPropagation()
    event.preventDefault()
    return false
  }
}, true)

// 屏蔽控制台的 ResizeObserver 错误
const originalConsoleError = console.error
console.error = (...args) => {
  // 检查参数是否存在且包含 ResizeObserver 相关信息
  if (args?.length > 0 && 
      ((args[0]?.message && typeof args[0].message === 'string' && args[0].message.includes('ResizeObserver')) || 
       (typeof args[0] === 'string' && args[0].includes('ResizeObserver')))) {
    return
  }
  originalConsoleError.apply(console, args)
}

// 添加全局的 unhandledrejection 处理
window.addEventListener('unhandledrejection', (event) => {
  if (event?.reason?.message && typeof event.reason.message === 'string' && 
      event.reason.message.includes('ResizeObserver')) {
    event.preventDefault()
    return false
  }
})

// 添加请求拦截器
axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(response => {
  return response
}, error => {
  const path = router.currentRoute.value?.path || ''
  if (path.startsWith('/admin') && error.response) {
    switch (error.response.status) {
      case 401:
        router.push('/admin/login')
        break
      case 403:
        ElMessage.error('没有权限')
        break
      case 404:
        ElMessage.error('请求的资源不存在')
        break
      case 500:
        ElMessage.error('服务器错误')
        break
      default:
        ElMessage.error('网络错误')
    }
  }
  return Promise.reject(error)
})

// 添加全局路由跳转后的滚动处理
router.afterEach(() => {
  window.scrollTo(0, 0)
})

const app = createApp(App)

// 将 axios 和封装的 request 挂载到全局
app.config.globalProperties.$axios = axios
app.config.globalProperties.$request = request

app.use(router)
app.use(ElementPlus)
app.mount('#app') 